import axios from "axios";

export const saveDescriptions = async (setLoading, product, updatedDescriptions, token, setUpdatedDescriptions, setMessage, loadData) => {
    //GUARDAS DESCRIPCIONES
    setLoading(true);
    const dataObject = {
      articleId: product?.article.id_article,
      articleData: updatedDescriptions,
    };
    dataObject.articleData = dataObject.articleData.map((item) => {
      const attributeId = item.attributeId;
      //if (approvedInputs.hasOwnProperty(attributeId)) {
      item.isApproved = true;
      //}
      return item;
    });

    if (product?.orderId) dataObject["orderId"] = product?.orderId;
    // console.log("dataObject", dataObject);
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_ARTICLE_DESCRIPTION_UPDATE_ENDPOINT}`,
        dataObject,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (res.data.statusCode === 200) {
        setUpdatedDescriptions([]);
        setMessage("Descripciones guardadas con éxito");
        await loadData();
      }
    } catch (error) {
      console.log(error);
    }
  };
export const saveDatasheets = async (boxData, product, updatedDatasheets, approvedInputs, token, setUpdatedDatasheets, setMessage, loadData, setAutomaticDatasheetChanges) => {
    const parseBoxData = [];
    Object.entries(boxData).forEach(([, box], index) => {
      const { value } = box;
      const attributesIds = Object.keys(value);
      attributesIds.forEach((attributeId) => {
        const boxId = index + 1;
        const valueOfAtribute = value[attributeId];
        parseBoxData.push({
          attributeId,
          value: valueOfAtribute,
          boxId,
        });
      });
    });

    const dataObject = {
      articleId: product?.article.id_article,
      articleData: updatedDatasheets,
      ...(parseBoxData.length > 0 && { boxData: parseBoxData }),
    };
    dataObject.articleData = dataObject.articleData.map((item) => {
      const attributeId = item.attributeId;
      if (approvedInputs.hasOwnProperty(attributeId)) {
        item.isApproved = true;
      }
      return item;
    });

    if (product?.orderId) dataObject["orderId"] = product?.orderId;
    try {
      const res = await axios.put(
        `${process.env.REACT_APP_ARTICLE_DATASHEET_UPDATE_ENDPOINT}`,
        dataObject,
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (res.data.statusCode === 200) {
        setUpdatedDatasheets([]);
        setAutomaticDatasheetChanges([]);
        setMessage("Fichas técnicas guardadas");
        await loadData();
      }
    } catch (error) {
      console.log(error);
    }
  };

  